var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowershell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PowerShell_48",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.92 0 0 0.92 24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.01 -0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(2,119,189)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-23.99, -23.98)",
    d: "M 19.847 41.956 C 14.218000000000002 41.954 8.588000000000001 41.980000000000004 2.9589999999999996 41.943000000000005 C 0.10399999999999965 41.92400000000001 -0.4150000000000005 41.243 0.22799999999999976 38.418000000000006 C 2.4059999999999997 28.838000000000008 4.654999999999999 19.275000000000006 6.785 9.684000000000005 C 7.356 7.112 8.588 5.975 11.312 6 C 22.57 6.106 33.829 6.034 45.088 6.046 C 47.912 6.049 48.386 6.66 47.752 9.557 C 45.694 18.963 43.623000000000005 28.366 41.516000000000005 37.76 C 40.727000000000004 41.275999999999996 39.819 41.946999999999996 36.163000000000004 41.955 C 30.724 41.966 25.285 41.958 19.847 41.956 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-21.5, -24)",
    d: "M 25.057 23.922 C 24.448999999999998 23.235 23.942999999999998 22.655 23.526 22.19 C 21.096 19.462 18.87 16.92 16.463 14.321000000000002 C 15.361 13.132000000000001 15.010000000000002 11.977000000000002 16.333000000000002 10.803 C 17.64 9.643 18.925 9.745000000000001 20.124000000000002 11.08 C 23.464000000000002 14.797 26.800000000000004 18.518 30.195 22.183999999999997 C 31.463 23.552999999999997 31.167 24.483999999999998 29.771 25.499 C 24.412 29.394 19.084000000000003 33.332 13.761 37.277 C 12.565 38.164 11.424 38.386 10.456999999999999 37.076 C 9.390999999999998 35.631 10.376999999999999 34.771 11.482999999999999 33.962 C 15.437999999999999 31.069000000000003 19.386 28.164 23.317 25.237000000000002 C 23.865 24.83 24.595 24.267 25.057 23.922 z M 21.75 37 C 20.625 37 20 36 20 35 C 20 34 20.625 33 21.75 33 C 25.974 33 27.862000000000002 33 31.25 33 C 32.375 33 33 34 33 35 C 33 36 32.375 37 31.25 37 C 29.125 37 25 37 21.75 37 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowershell);
export default __webpack_public_path__ + "static/media/powershell.f143d42ce69428110e7e3d34339cb655.svg";
export { ForwardRef as ReactComponent };